import React from "react";
import { cn } from "../utils";
import { shell, typography } from "../tokens";
import { ModuleSidebarExpandControl } from "./module-sidebar";

export function AppHeader({ children, className }) {
  return (
    <header
      className={cn(
        shell.bg,
        "relative flex items-center justify-between gap-3 px-4 border-b flex-shrink-0 overflow-visible",
        shell.headerHeight,
        shell.border,
        "z-[220]",
        className
      )}
    >
      {children}
    </header>
  );
}

export function HeaderGroup({ children, className, ...props }) {
  return <div className={cn("flex items-center gap-2", className)} {...props}>{children}</div>;
}

export function HeaderTitle({ children, className }) {
  return (
    <h1 className={cn("m-0 text-gray-900", className)} style={typography.pageTitle}>
      {children}
    </h1>
  );
}

export function HeaderIconButton({ children, className, ...props }) {
  return (
    <button
      type="button"
      className={cn(
        "p-1.5 rounded-lg text-gray-500 hover:text-gray-900 hover:bg-gray-100 transition-colors",
        "focus-visible:ring-2 focus-visible:ring-blue-400 focus:outline-none",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}

export function HeaderDropdown({ open, children, className, width = "w-72", align = "right" }) {
  if (!open) return null;
  return (
    <div
      className={cn(
        "absolute top-[calc(100%+6px)] bg-white rounded-xl shadow-lg overflow-hidden animate-fade-slide-down",
        align === "right" ? "right-0" : "left-0",
        width,
        "max-w-[calc(100vw-1rem)]",
        "z-[300]",
        className
      )}
      style={{ border: "0.5px solid #d1d5db" }}
    >
      {children}
    </div>
  );
}

export function HeaderDropdownSection({ children, className, bordered }) {
  return (
    <div className={cn(bordered && "border-b border-gray-100", className)}>
      {children}
    </div>
  );
}

export function HeaderDropdownItem({ children, className, as: Comp = "button", ...props }) {
  return (
    <Comp
      className={cn(
        "w-full text-left px-4 py-2.5 text-gray-700 hover:bg-gray-50 transition-colors flex items-center gap-2",
        className
      )}
      style={{ fontSize: "0.83rem" }}
      {...props}
    >
      {children}
    </Comp>
  );
}

export function HeaderDropdownTitle({ children }) {
  return (
    <div className="px-4 py-2.5 border-b border-gray-100 text-gray-700" style={{ ...typography.bodyBold, fontSize: "0.82rem" }}>
      {children}
    </div>
  );
}

/** Flat 64px module content header (Controls, Audit, TPRM, …). */
export function ModulePageHeader({
  sidebarOpen,
  onExpandSidebar,
  expandTitle = "Expand sidebar",
  title,
  actions,
  className,
}) {
  return (
    <div
      className={cn(
        "flex-shrink-0 flex items-center bg-white border-b border-gray-200 px-3 h-[64px] gap-2",
        className
      )}
    >
      <ModuleSidebarExpandControl
        open={sidebarOpen}
        onExpand={onExpandSidebar}
        expandTitle={expandTitle}
      />
      <h1 className="text-[15px] font-semibold text-gray-700 truncate flex-1 min-w-0 m-0">{title}</h1>
      {actions ? <div className="flex items-center gap-2 flex-shrink-0">{actions}</div> : null}
    </div>
  );
}
